<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- foto, nome e função -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <!-- foto -->
          <img
            class="w-10 h-10 rounded-full"
            :src="
              !row['image_profile']
                ? defaultImg
                : imageServe + row['image_profile']
            "
            :alt="'Foto de ' + row['name']"
          />

          <!-- nome e função -->
          <div class="ps-3">
            <div class="text-base font-semibold">
              {{ row["name"] }}
            </div>

            <!-- <div class="font-normal text-gray-500">
              {{ row["function"] }}
            </div> -->
          </div>
        </th>

        <!-- cell e email -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <div title="CPF" class="text-base text-gray-900">
              {{ row["phone"] ? row["phone"] : "não informado" }}
            </div>

            <div class="font-normal text-gray-500 lowercase">
              {{
                row["email"]?.length > 20
                  ? row["email"].slice(0, 20).concat("...")
                  : row["email"] ?? "não informado"
              }}
            </div>
          </div>
        </td>

        <!-- função -->
        <td class="px-1 py-4">
          <div class="flex items-center">
            {{ row["function"] }}
          </div>
        </td>

        <!-- tipo de acesso -->
        <td class="px-6 py-4">
          <div class="text-center">
            {{ row["permission_type"] }}
          </div>
        </td>

        <!-- ações -->
        <td class="px-6 py-4">
          <div class="flex justify-center font-medium">
            <!-- editar -->
            <router-link
              title="Alterar dados do colaborador"
              class="text-yellow-600 mr-1 hover:underline cursor-pointer"
              :to="'/collab/edit/' + row['id']"
            >
              <component :is="PhNotePencil" class="h-6 w-6" />
            </router-link>

            <!-- relatórios -->
            <!-- <a
              title="Gerar relatório"
              @click="showReport(row)"
              class="text-green-600 ml-1 hover:underline cursor-pointer"
            >
              <component :is="PhFileDoc" class="h-6 w-6" />
            </a> -->

            <!-- remover -->
            <a
              :title="'Desativar ' + row['name'] + ' da lista'"
              @click="deleteEmployee(row['id'])"
              class="text-red-600 ml-1 hover:underline cursor-pointer"
            >
              <component :is="PhTrash" class="h-6 w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import ReportModal from "@/components/Modals/Reports.vue";
import collabService, { PATH } from "../services/collab.service";
import Create from "@/components/Buttons/Create.vue";
import Preview from "./Report/Preview.vue";
import moment from "moment";
import {
  PhFileDoc,
  PhNotePencil,
  PhPencilCircle,
  PhPencilSimple,
  PhPenNib,
  PhTrash,
  PhWhatsappLogo,
} from "@phosphor-icons/vue";
import { PdfCreate } from "@/utils/reports/generate-blob";
import { showToast as toast } from "@/helpers/UseToasts";
import { defineProps, ref } from "vue";
import { storeApp } from "@/store";

const imageServe = process.env.VUE_APP_IMAGE_SERVE + "storage/";
const defaultImg = require("@/assets/logo/icon.png");

const props = defineProps({
  data: [Object, Array],
});

const emit = defineEmits(["delete"]);

async function deleteEmployee(id) {
  storeApp.state.loading = true;
  const confirm = window.confirm("Deseja realmente remover esse colaborador?");
  if (confirm) {
    collabService
      .deleteCollaborator(id)
      .then((res) => {
        if (res.data.success) {
          toast("Sucesso", res.data.success, "success");
        }
        window.location.reload();
      })
      .catch((err) => {
        toast("Aviso", err.response.data.error, "error");
      });
  }
  storeApp.state.loading = false;
}

function formatDate(date) {
  if (date !== null) {
    return moment(date).format("D/MM/Y");
  }

  return "não informado";
}
</script>
